















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ProgressBar extends Vue {
  @Prop({ default: 100 }) max?: number;
  @Prop({ default: 0 }) min?: number;
  @Prop({ default: 0 }) value?: number;
  @Prop({ default: '10px' }) height?: string;
  @Prop({ default: '100%' }) width?: string;
  @Prop({ default: 1000 }) transitionDuration?: number;

  get borderRadius() {
    if (this.height) {
      const [value] = this.height.split('px');
      return Number(value) / 2;
    }
    return 5;
  }

  get percentage() {
    return (
      (100 * ((this.value || 0) - (this.min || 0))) /
      ((this.max || 100) - (this.min || 0))
    );
  }
}
